<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-multiselect
    [ngClass]="{'fx-fill': settings.fxFill}"
    [data]="proofDocuments$ | async"
    [formControl]="control" 
    valueField="id"
    textField="id"
    valuePrimitive="true"
    (valueChange)="onChange($event)">

    <ng-template kendoMultiSelectItemTemplate let-item>
        <strong [ngClass]="item.conformityId == 2 ? 'conformed' : 'non-conformed' " >{{item.typeId | staticDictionaryCaption:'proofDocumentType' | async }}</strong>
        <span class="additionalInfo">  - ( {{item.kindId | staticDictionaryCaption:'proofDocumentKind' |async}} / {{item.conformityId | staticDictionaryCaption:'proofDocumentConformity' |async}} ) </span>
       
      </ng-template>

       <ng-template kendoMultiSelectTagTemplate let-item>
        <strong>{{item.typeId | staticDictionaryCaption:'proofDocumentType' | async }}</strong>
      </ng-template> 

</kendo-multiselect>

</kendo-formfield>